import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Question, Answer } from '@df/interfaces';
import { TaskService } from '@app/core/services/task.service';

@Component({
    selector: 'app-question-logic',
    templateUrl: './question-logic.component.html',
    styleUrls: ['./question-logic.component.scss']
})
export class QuestionLogicComponent implements OnInit {
    @Input() question: Question;
    @Input() exercise;
    @Input() cardId: number;
    @Input() qIndex: number;
    @Input() studentId: number;
    @Input() isAuthorCard: boolean;
    @Input() isAccessCard: boolean;
    @Input() prev_results: Array<any> = [];
    @Output() questionAnswered = new EventEmitter();
    answerStr: string;

    constructor(private taskService: TaskService) {}

    ngOnInit() {
        if (this.prev_results) {
            this.prev_results.forEach(item => {
                if (this.exercise.id === item.exercise_id) {
                    this.answerStr = item.short_answer;
                    this.answerInputChange(item.short_answer);
                }
            });
            return;
        }
        this.answerStr = this.question.answers[0].shortAnswer;
    }

    clearAnswer(event) {
        this.answerStr = '';
        this.isEmptyAnswer(event);
    }

    answerInputChange(event) {
        const questionCorrect: boolean = this.checkQuestionAnswer();
        const answerObject: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: this.answerStr,
            exercise: this.exercise.id,
            correct: questionCorrect,
            question: this.question.id
        };

        for (const exerAnswer of this.exercise.answers) {
            if (questionCorrect) {
                if (this.answerStr === exerAnswer.shortAnswer) {
                    answerObject.shortAnswer = this.answerStr;
                } else {
                    answerObject.fullAnswer = this.answerStr;
                }
                break;
            } else {
                answerObject.shortAnswer = this.answerStr;
                answerObject.correct = false;
            }
        }
        if (event) {
            this.questionAnswered.emit(answerObject);
        }
    }

    checkQuestionAnswer(): boolean {
        return this.taskService.checkCorrectAnswer(this.answerStr, this.question);
    }

    addWord(word: string) {
        if (this.answerStr === '') {
            this.answerStr = word;
        } else {
            this.answerStr = this.answerStr + ', ' + word;
        }
        this.answerInputChange(this.answerStr);
    }

    isEmptyAnswer(event) {
        if (this.answerStr === '') {
            if (event) {
                this.answerInputChange(event);
            }
            return true;
        }
        return false;
    }
}
